export default {
    routerName: '菜单详情',
    menu: {
        frontEndName: 'フロントエンドショー',
        backEndName: 'バックエンド管理',
        parentName: '親ノード名',
        menuName: 'メニュー名',
        buttonName: 'ボタン名',
        icon: 'アイコン',
        url: 'URL',
        permit: '権限',
        sortOrder: 'ソート',
        type: 'タイプ',
        catalog: 'ディレクトリ',
        typeMenu: 'メニュー',
        typeButton: 'ボタン',
        status: '状態',
        statusOpen: '有効',
        statusClose: '無効',
    },
};
